var exports = {
  "I": "x31de4314--dddc18--distance",
  "K": "x31de4314--dddc18--icon",
};

module.exports = exports;
